import { Close } from '@mui/icons-material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import React from 'react';
import { useTranslation } from 'react-i18next';

const FileDrawer = ({ open, onClose, name, data, setSingleFile, setPdfDialogOpen }) => {
  const { t } = useTranslation('translations');

  const getFileName = (path = '') => path.split('/').pop();

  const handleShowPdf = (path) => {
    setPdfDialogOpen(true);
    setSingleFile(path);
    onClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: { md: 400, xs: 343 } }} role="presentation">
        <div className="flex gap-10 items-center pt-16 pl-3">
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
          <h4 className="font-inter font-700 text-xl text-[#16151c] dark:text-white">{name}</h4>
        </div>
        {data?.files && data?.files?.length > 0 && (
          <div className="mt-10 p-7">
            <p className="mb-6">{t('AttachedFiles')}</p>
            {data?.files?.map((f, index) => (
              <div
                key={index}
                className="rounded-lg p-5 bg-white dark:bg-[#1a1a1a] border-2 border-solid mb-5"
              >
                <p
                  className="font-medium hover:underline cursor-pointer"
                  onClick={() => handleShowPdf(f)}
                >
                  <AttachFileIcon color="info" fontSize="small" />
                  {getFileName(f)}
                </p>
              </div>
            ))}
          </div>
        )}
      </Box>
    </Drawer>
  );
};

export default FileDrawer;
